var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:_vm.className,style:({ 'background-color': _vm.color }),attrs:{"scope":"col"}},[_c('div',{class:_vm.classInner,style:({ 'color': _vm.getFontColor })},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f9e18f4","hasScoped":true,"transformToRequire":{"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableHeading.vue
// module id = CpQ/
// module chunks = 1